import { render, staticRenderFns } from "./FormaCodeDiscountBanner.vue?vue&type=template&id=0d126511"
import script from "./FormaCodeDiscountBanner.vue?vue&type=script&lang=js"
export * from "./FormaCodeDiscountBanner.vue?vue&type=script&lang=js"
import style0 from "./FormaCodeDiscountBanner.vue?vue&type=style&index=0&id=0d126511&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports